module.exports = __webpack_public_path__ + "static/media/appweb2.343bbbc8.webp";